<template>
<v-app-bar
tile
flat
color="white"
 app>
  <div class="head-contents-box" style="width:100%">
    <div class="head-contents">
       <img src="https://qlipper.jp/img/logo.svg" alt="Qlipper" class="head-logoimg"  />
   </div>
  </div><!-- /.head-contents-box -->
</v-app-bar>
</template>
<script>
export default{
    data : function(){
        return {
            drawer: false,
            searchUse   : 0,
            searchUnuse : 0,
        };
    },
}
</script>
<style>
.head-logoimg
{
	width : 80px;
}

</style>
